import { Link } from "react-router-dom";

const SectionTitle = ({
    title,
    buttonText,
    buttonUrl,
    backUrl,
    children,
}: {
    title: string;
    buttonText?: string;
    buttonUrl?: string;
    backUrl?: string;
    children?: JSX.Element[] | JSX.Element;
}) => {
    return (
        <div className="mb-5">
            {backUrl && (
                <Link className="btn btn-outline-primary" to={backUrl}>
                    Back
                </Link>
            )}
            <div
                className={`d-md-flex align-items-center justify-content-between ${
                    backUrl ? "mt-4" : ""
                }`}
            >
                <h3 className="mb-md-0">{title}</h3>
                <div className="d-flex align-items-center">
                    {children && children}
                    {buttonUrl && (
                        <Link to={buttonUrl} className="btn btn-primary btn-lg" title={buttonText}>
                            {buttonText ?? "Create"}
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SectionTitle;
